import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { UserProfileService } from '../../services/user-profile.service';
import { CountrySelectionService } from '../../services/country-selection.service';

@Component({
  selector: 'app-first-visit-popup',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule],
  templateUrl: './first-visit-popup.component.html',
  styleUrls: ['./first-visit-popup.component.css']
})
export class FirstVisitPopupComponent implements OnInit {
  firstVisitForm: FormGroup;
  @Output() popupClosed = new EventEmitter<void>();
  countries: any[] = [];

  constructor(
    private fb: FormBuilder,
    private userProfileService: UserProfileService,
    private countrySelectionService: CountrySelectionService
  ) {
    this.firstVisitForm = this.fb.group({
      countryOffice: [null, Validators.required],
      'Current-User-Language': ['en', Validators.required]
    });
  }

  ngOnInit(): void {
    this.countries = this.countrySelectionService.getCountries();
    if (this.countries.length > 0) {
      this.firstVisitForm.patchValue({ countryOffice: this.countries[0] });
    }
  }

  onSubmit() {
    if (this.firstVisitForm.valid) {
      this.userProfileService.saveProfileData(this.firstVisitForm.value);
      this.countrySelectionService.setSelectedCountry(this.firstVisitForm.value.countryOffice);
      this.popupClosed.emit();
    }
  }
}
